export default __webpack_public_path__ + "static/media/clock.a85413d2.svg";